import { Text } from '@wartek-id/text'
import { Avatar } from '@wartek-id/avatar'

import ArrowAltRight from 'assets/icons/arrow-alt-right-o.svg'

interface ModulePageHeadingProps {
  name: string
  reviewer: {
    name: string
    imageUrl: string
  }
  onToggleClick: () => void
}

const ModulePageHeading = ({
  name,
  reviewer,
  onToggleClick,
}: ModulePageHeadingProps) => {
  return (
    <div className="px-4 py-4 bg-expressive-dark-blue text-white">
      <div className="mb-1">
        <Text as="span" variant="body-sm" color="inverse" className="uppercase">
          Modul
        </Text>
      </div>
      <div className="mb-2">
        <Text variant="heading-lg" color="inverse">
          {name}
        </Text>
      </div>
      <div className="flex items-center mb-4">
        <div className="flex-shrink-0 w-6 h-6">
          <Avatar
            name={reviewer?.name}
            alt=""
            shape="circle"
            size="sm"
            src={reviewer?.imageUrl}
          />
        </div>
        <div className="ml-3">
          <Text variant="body-sm" color="inverse">
            Dikembangkan oleh {reviewer?.name}
          </Text>
        </div>
      </div>
      <div>
        <button
          data-testid="toggle-detail"
          onClick={onToggleClick}
          className="flex justify-center items-center border-none bg-transparent focus:outline-none"
          type="button"
        >
          <Text variant="action" color="inverse" className="mr-1 underline">
            Baca detail modul
          </Text>
          <ArrowAltRight className="text-white stroke-current" />
        </button>
      </div>
    </div>
  )
}

export default ModulePageHeading
